module.exports = __webpack_public_path__ + "img/handmade-user-circle__dark.80ddb336.svg";